import { css } from "@emotion/react";

export const branchesMenuStyles = ({ shouldShowSearch }) => {
  return css`
    .branches-dropdown-header {
      padding: ${shouldShowSearch ? "0" : "1rem 1rem 0"};

      .main-branch-switch {
        padding: 0.25rem 0;
      }
    }
  `;
};
